<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <ng-container
            ><mat-form-field class="columns-9">
                <mat-label appRemoveAriaOwns>{{ 'time-off-v3.country' | translate: { year } }}</mat-label>
                <mat-select
                    placeholder="Select a country"
                    [(ngModel)]="country"
                    name="country"
                    type="text"
                    required
                    #countrySelect="ngModel"
                >
                    <mat-option value="Canada">{{ 'time-off-v3.canada' | appTranslate }}</mat-option>
                    <mat-option value="United States">{{ 'time-off-v3.unitedStates' | appTranslate }}</mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>

        <ng-container>
            <mat-form-field *ngIf="country" class="columns-9">
                <mat-label>{{ 'time-off-v3.region' | translate }}</mat-label>
                <ui-state-autocomplete
                    name="provinceName"
                    #state="ngModel"
                    required
                    [country]="country"
                    [(ngModel)]="province"
                    placeholder="{{ 'time-off-v3.selectRegion' | translate }}"
                ></ui-state-autocomplete>
                <mat-error *ngIf="state.invalid">{{ state.errors | formErrors }}</mat-error>
            </mat-form-field>
        </ng-container>
    </div>
</form>
